import React from 'react';
import PropTypes from 'prop-types';

import { styled } from '@mui/system';
import MuiCardHeader from '@mui/material/CardHeader';

import { MENU_ITEM_NAMES } from 'styles/constants/appearanceSectionNames';
import MenuItemNameTypography from 'components/MenuItemNameTypography';

const StyledCardHeader = styled(MuiCardHeader)(({ theme }) => ({
  '& .MuiCardHeader-title': {
    '&.Mui-disabled': {
      color: theme.palette.text.disabled
    }
  }
}));

function CardHeader({ title, disabled }) {
  const styles = { variant: MENU_ITEM_NAMES };

  return (
    <StyledCardHeader
      disabled={disabled}
      disableTypography
      title={
        <MenuItemNameTypography {...styles}>{title}</MenuItemNameTypography>
      }
    />
  );
}

CardHeader.propTypes = {
  title: PropTypes.string.isRequired,
  disabled: PropTypes.bool
};

export default CardHeader;
